/*@ngInject*/
const RadioButtonGroupController = function ($scope, $controller, formComponentUtil, formMediator, coreConstant) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}), $controller('baseDataSetFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        const dataSetImmediateLoad = true;
        const preventDataSetLoadIfConfigurableComponent = false;

        this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(() => {
            this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(this.fieldStructure.layout, this.itemsList);
        });
    };

    this.$onChanges = function () {
        this.onChanges();
    };

    this.getGroupName = function (uiField) {
        return uiField.fieldTemplate.variableName + this.fieldStructure.parentForm.formTemplateUniqueName + (this.isRowRepeater() ? ':' + this.fieldStructure.rowNumber : '');
    };

    this.handleChange = function (selectedItem) {
        this.fieldStructure.hasLocalChanges = true;

        if(!_.isNil(selectedItem.name)) {
            this.fieldStructure.fieldModel.valueLabel = selectedItem.name;
        }

        formComponentUtil.setupFieldProperties(this.fieldStructure);

        formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    };

    this.handleClick = function (event, selectedItem) {
        if (this.fieldStructure.dynamicProperties.disabled) {
            return;
        }

        if (event.ctrlKey) {
            this.fieldStructure.fieldModel.value = null;
            this.handleChange(selectedItem);
        }
    };

    this.updateItems = function (updateEvent, data) {
        if (this.shouldUpdateItems(updateEvent, data)) {
            this.itemsList = _.cloneDeep(data.items);
            this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(this.fieldStructure.layout, this.itemsList);
        }
    };

    $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));
};

angular.module('umFormViewer')
    .controller('radioButtonGroupController', RadioButtonGroupController);
